import { Link } from "react-router-dom";
import { Puzzle } from "lucide-react";
import type { ModuleKey } from "@gaole/shared";
import { moduleLabel } from "@gaole/shared";
import { useAuth } from "../stores/auth";
import { Button, EmptyState, PageLoader } from "./ui";

export function RequireModule({ module, children }: { module: ModuleKey; children: React.ReactNode }) {
  const loading = useAuth((s) => s.loading);
  const moduleEnabled = useAuth((s) => s.moduleEnabled);

  if (loading) return <PageLoader />;
  if (!moduleEnabled(module)) {
    return (
      <EmptyState
        icon={Puzzle}
        title="Module disabled"
        hint={`${moduleLabel(module)} is turned off. Enable it under Admin → Modules to use this page.`}
        action={
          <div className="flex flex-wrap justify-center gap-2">
            <Link to="/">
              <Button variant="outline">Dashboard</Button>
            </Link>
            <Link to="/admin/modules">
              <Button>Modules</Button>
            </Link>
          </div>
        }
      />
    );
  }
  return <>{children}</>;
}
